export default __webpack_public_path__ + "static/media/SchoolProject1.a7e30535.png";